import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { BrandMark } from './BrandMark';
const navItems = [{
  label: 'Work',
  hash: 'work'
}, {
  label: 'About',
  hash: 'about'
}, {
  label: 'Contact',
  hash: 'contact'
}];
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const {
    pathname
  } = useLocation();
  const reduceMotion = useReducedMotion();
  const isHome = pathname === '/';
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleLogoNavigation = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isHome) return;
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const hashLink = (hash: string) => isHome ? `#${hash}` : `/#${hash}`;
  const handleSamePageNavigation = (event: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    if (!isHome) return;
    event.preventDefault();
    const target = document.getElementById(hash);
    if (!target) return;
    const headerOffset = 88;
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  };
  return <motion.header initial={reduceMotion ? false : {
    y: -16,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.3,
    ease: [0.22, 1, 0.36, 1]
  }} style={{
    WebkitBackfaceVisibility: 'hidden',
    backfaceVisibility: 'hidden'
  }} className={`fixed inset-x-0 top-0 z-50 isolate border-b border-border/70 bg-background/75 backdrop-blur-xl ${scrolled ? 'shadow-[0_1px_0_rgba(17,17,17,0.03)]' : ''}`} data-id="element-359" data-mp="2hu7f3v7axoun">
      <div className="site-container flex min-h-[64px] items-center justify-between sm:min-h-[72px]" data-id="element-360" data-mp="30mibr7bd4qkb">
        <Link to="/" onClick={handleLogoNavigation} aria-label="Kusminov — Home" className="group flex h-9 w-9 items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cobalt focus-visible:ring-offset-4" data-id="element-361" data-mp="2vrm8fb0oegrw">
          <BrandMark className="h-9 w-9" data-id="element-362" data-mp="k499x4gvuv84" />
        </Link>

        <nav className="flex items-center gap-4 sm:gap-8" aria-label="Primary navigation" data-id="element-363" data-mp="p4nay2k2h4wn">
          {navItems.map((item, index) => <motion.a key={item.hash} href={hashLink(item.hash)} onClick={event => handleSamePageNavigation(event, item.hash)} initial={reduceMotion ? false : {
          y: -6,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.28,
          delay: reduceMotion ? 0 : 0.14 + index * 0.06,
          ease: [0.22, 1, 0.36, 1]
        }} className="group relative py-2 font-display text-sm font-medium uppercase tracking-[0.08em] text-foreground transition-colors duration-200 hover:text-cobalt focus-visible:outline-none focus-visible:text-cobalt sm:text-base sm:tracking-[0.1em]" data-id="element-364" data-mp="a6utv5yvg8gc" data-mpi={index}>
              {item.label}
              <span className="absolute bottom-0 left-0 h-px w-0 bg-cobalt transition-[width] duration-200 ease-out group-hover:w-full group-focus-visible:w-full" data-id="element-365" data-mp="2jhvtk28x49z2" />
            </motion.a>)}
        </nav>
      </div>
    </motion.header>;
}